var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trade-history-list',{attrs:{"login-type":_vm.loginType}})
}
var staticRenderFns = []

export { render, staticRenderFns }